module.exports = new __parcel__URL__("chevron-left.25a630df.svg").toString();